import Axios from "axios";
const network = Axios.create({ withCredentials: false });
const useAutoComplete = () => ({
  getAutofillSuggestions
});
function getAutofillSuggestions({
  name = null,
  cin = null,
  limit = 5,
  filter = "active"
}) {
  const apiToken = "f639d8d3ff0b9172721f468f8d71c99699cbcda3366b6ac7278446f012fc538483a62815865264cc";
  if (!name && !cin) {
    return Promise.reject();
  }
  const q = name ? `name:${name}` : `cin:${cin}`;
  const endpoint = "https://autoform.ekosystem.slovensko.digital/api/corporate_bodies/search?q=" + encodeURIComponent(q) + "&limit=" + encodeURIComponent(limit) + "&filter=" + encodeURIComponent(filter) + "&private_access_token=" + apiToken;
  return network.get(endpoint).then((result) => {
    return result.data;
  }).catch(() => []);
}
export {
  useAutoComplete
};
//# sourceMappingURL=autoComplete.service.es.js.map
